import { jsx as _jsx } from "react/jsx-runtime";
import BaseFieldDetail from "../base/detail";
import { FieldViewType } from "../viewType";
/** <b>Composant en mode consultation/detail d'un champ de type text</b>*/
export default function TextFieldList(_a) {
    var record = _a.record, fieldName = _a.fieldName;
    return (_jsx(BaseFieldDetail, { record: record, fieldName: fieldName, viewType: FieldViewType.DETAIL }));
}
